function inStoreCurbsidePickupMessage(productModel, checkCutOffTimeFlag, checkPickupEligibilityFlag) {
  // inStoreCurbsideCutoffTimeEnabled KS set to true then display time in pickupMessageLine2
  const inStoreCurbsideCutoffTimeEnabled = productModel.get('properties') && productModel.get('properties').inStoreCurbsideCutoffTimeEnabled;
  const {
    deliveryDay, otherDate, pickupCutOffTime, pickupOptions, cutOffTime, curbsideCutOffTime,
  } = productModel.get('product').store;
  const deliveryDayLower = deliveryDay && deliveryDay.toLowerCase();
  const pickupMessageLine1 = deliveryDayLower;
  let pickupMessageLine2 = '';
  let pickupTimeMessage = '';
  let fireLinkTagMessage = '';
  let formattedMessage = '';
  let formattedCurbsideMessage = '';
  let inStorePickupRelativeDayUpper = 'NA';
  let curbsidePickupRelativeDayUpper = 'NA';
  let formattedStoreMessage;

  // get in store pickupRelativeDay for tagging
  if (typeof cutOffTime !== 'undefined' && typeof cutOffTime.pickupRelativeDay !== 'undefined') {
    inStorePickupRelativeDayUpper = cutOffTime.pickupRelativeDay.toUpperCase();
  }
  // get curbside pickupRelativeDay for tagging
  if (typeof curbsideCutOffTime !== 'undefined' && typeof curbsideCutOffTime.pickupRelativeDay !== 'undefined') {
    curbsidePickupRelativeDayUpper = curbsideCutOffTime.pickupRelativeDay.toUpperCase();
  }
  // switch statment checks for cutOffTimes and inStore/curbside eligibility to determine which message to display for Curbside 2.0:
  switch (true) {
    case (checkCutOffTimeFlag === 'noDates' && checkPickupEligibilityFlag === 'bothEligible'):
      pickupMessageLine2 = 'For <span class="bold">Curbside</span> or <span class="bold">In Store Pickup.</span>';
      formattedMessage = deliveryDayLower === 'tomorrow' ? 'TOMORROW' : 'OTHER';
      fireLinkTagMessage = `In Store:${formattedMessage}-Curbside:${formattedMessage}`;
      break;
    case (checkCutOffTimeFlag === 'pickupCutOffTimeOnly' && checkPickupEligibilityFlag === 'bothEligible'):
      pickupTimeMessage = inStoreCurbsideCutoffTimeEnabled && pickupCutOffTime ? `<span>Order by ${pickupCutOffTime} for</span>` : 'For';
      pickupMessageLine2 = `${pickupTimeMessage} <span class="bold">Curbside</span> or <span class="bold">In Store Pickup.</span>`;
      formattedMessage = deliveryDayLower.toUpperCase();
      fireLinkTagMessage = `In Store:${formattedMessage}-Curbside:${formattedMessage}`;
      break;
    case (checkCutOffTimeFlag === 'otherDateOnly' && checkPickupEligibilityFlag === 'bothEligible'):
      pickupMessageLine2 = `For <span class="bold">${pickupOptions[0]} Pickup.</span> Eligible for <span class="bold">${pickupOptions[1]} Pickup</span> on ${otherDate}.`;
      fireLinkTagMessage = `In Store:${inStorePickupRelativeDayUpper}-Curbside:${curbsidePickupRelativeDayUpper}`;
      break;
    case (checkCutOffTimeFlag === 'bothDates' && checkPickupEligibilityFlag === 'bothEligible'):
      pickupTimeMessage = inStoreCurbsideCutoffTimeEnabled && pickupCutOffTime ? `<span>Order by ${pickupCutOffTime} for</span>` : 'For';
      pickupMessageLine2 = `${pickupTimeMessage} <span class="bold">${pickupOptions[0]} Pickup.</span> Eligible for <span class="bold">${pickupOptions[1]} Pickup</span> on ${otherDate}.`;
      fireLinkTagMessage = `In Store:${inStorePickupRelativeDayUpper}-Curbside:${curbsidePickupRelativeDayUpper}`;
      break;
    case (checkPickupEligibilityFlag === 'inStoreEligibleOnly' && deliveryDayLower === 'today'):
      pickupTimeMessage = inStoreCurbsideCutoffTimeEnabled && pickupCutOffTime ? `<span>Order by ${pickupCutOffTime} for</span>` : 'For';
      pickupMessageLine2 = `${pickupTimeMessage} <span class="bold">${pickupOptions[0]} Pickup. Curbside Pickup</span> is unavailable at this time.</span>`;
      formattedStoreMessage = deliveryDayLower.toUpperCase();
      fireLinkTagMessage = `In Store:${formattedStoreMessage}-Curbside:NA`;
      break;
    case (checkPickupEligibilityFlag === 'inStoreEligibleOnly' && deliveryDayLower !== 'today'):
      pickupMessageLine2 = `For <span class="bold">${pickupOptions[0]} Pickup. Curbside Pickup</span> is unavailable at this time.</span>`;
      formattedStoreMessage = deliveryDayLower === 'tomorrow' ? 'TOMORROW' : 'OTHER';
      fireLinkTagMessage = `In Store:${formattedStoreMessage}-Curbside:NA`;
      break;
    case (checkPickupEligibilityFlag === 'curbsideEligibleOnly' && deliveryDayLower !== 'today'):
      pickupMessageLine2 = `For <span class="bold">${pickupOptions[0]} Pickup. In Store Pickup</span> is unavailable at this time.</span>`;
      formattedCurbsideMessage = deliveryDayLower === 'tomorrow' ? 'TOMORROW' : 'OTHER';
      fireLinkTagMessage = `In Store:NA-Curbside:${formattedCurbsideMessage}`;
      break;
    case (checkPickupEligibilityFlag === 'curbsideEligibleOnly' && deliveryDayLower === 'today'):
      pickupTimeMessage = inStoreCurbsideCutoffTimeEnabled && pickupCutOffTime ? `<span>Order by ${pickupCutOffTime} for</span>` : 'For';
      pickupMessageLine2 = `${pickupTimeMessage} <span class="bold">${pickupOptions[0]} Pickup. In Store Pickup</span> is unavailable at this time.</span>`;
      formattedCurbsideMessage = deliveryDayLower.toUpperCase();
      fireLinkTagMessage = `In Store:NA-Curbside:${formattedCurbsideMessage}`;
      break;
    case (checkPickupEligibilityFlag === 'notEligible'):
      fireLinkTagMessage = 'In Store:NA-Curbside:NA';
      break;
    default:
      break;
  }
  productModel.get('viewState').pickupMessageLine1 = pickupMessageLine1;
  productModel.get('viewState').pickupMessageLine2 = pickupMessageLine2;
  productModel.get('viewState').fireLinkTagBopsMessage = fireLinkTagMessage;
}
function checkCutOffTime(productModel) {
  const { otherDate, pickupCutOffTime } = productModel.get('product').store;
  let conditionalCheck = '';
  switch (true) {
    case (typeof pickupCutOffTime === 'undefined' && typeof otherDate === 'undefined'):
      conditionalCheck = 'noDates';
      break;
    case (typeof pickupCutOffTime !== 'undefined' && typeof otherDate === 'undefined'):
      conditionalCheck = 'pickupCutOffTimeOnly';
      break;
    case (typeof pickupCutOffTime === 'undefined' && typeof otherDate !== 'undefined'):
      conditionalCheck = 'otherDateOnly';
      break;
    case (typeof pickupCutOffTime !== 'undefined' && typeof otherDate !== 'undefined'):
      conditionalCheck = 'bothDates';
      break;
    default:
      break;
  }
  return conditionalCheck;
}

function checkPickupEligibility(productModel) {
  let inStorePickupEligibility = false;
  let curbsidePickupEligibility = false;
  if (typeof productModel.get('product').store !== 'undefined' && typeof productModel.get('product').store.details !== 'undefined') {
    ({ inStorePickupEligibility } = productModel.get('product').store.details);
    ({ curbsidePickupEligibility } = productModel.get('product').store.details);
  }
  let conditionalCheck = '';
  switch (true) {
    case (inStorePickupEligibility && curbsidePickupEligibility):
      conditionalCheck = 'bothEligible';
      break;
    case (inStorePickupEligibility === true && curbsidePickupEligibility === false):
      conditionalCheck = 'inStoreEligibleOnly';
      break;
    case (inStorePickupEligibility === false && curbsidePickupEligibility === true):
      conditionalCheck = 'curbsideEligibleOnly';
      break;
    default:
      conditionalCheck = 'notEligible';
      break;
  }
  return conditionalCheck;
}
function bossPickupMessagging(productModel) {
  let pickupAvailabilityMessage = 'NA';
  let inStorePickupEligibility = false;
  let curbsidePickupEligibility = false;
  if (typeof productModel.get('viewState').detail.selectedUpcItem !== 'undefined' && typeof productModel.get('viewState').detail.selectedUpcItem.availability !== 'undefined') {
    pickupAvailabilityMessage = productModel.get('viewState').detail.selectedUpcItem.availability.pickupAvailabilityMessage ? productModel.get('viewState').detail.selectedUpcItem.availability.pickupAvailabilityMessage : 'NA';
    pickupAvailabilityMessage = pickupAvailabilityMessage.replace(/-/g, ' TO ').toUpperCase();
  }
  if (typeof productModel.get('product').store !== 'undefined' && typeof productModel.get('product').store.details !== 'undefined') {
    ({ inStorePickupEligibility } = productModel.get('product').store.details);
    ({ curbsidePickupEligibility } = productModel.get('product').store.details);
  }
  let bossMessage = '';
  let fireLinkTagMessage = '';
  // check In Store and Curbside eligibility to determine boss messaging
  switch (true) {
    case (inStorePickupEligibility === true && curbsidePickupEligibility === true):
      bossMessage += 'For <span class="bold">Curbside</span> or <span class="bold">In Store Pickup.</span>';
      fireLinkTagMessage = `In Store:${pickupAvailabilityMessage}-Curbside:${pickupAvailabilityMessage}`;
      break;
    case (inStorePickupEligibility === true && curbsidePickupEligibility === false):
      bossMessage += 'For <span class="bold">In Store Pickup. Curbside Pickup</span> is unavailable at this time.';
      fireLinkTagMessage = `In Store:${pickupAvailabilityMessage}-Curbside:NA`;
      break;
    case (inStorePickupEligibility === false && curbsidePickupEligibility === true):
      bossMessage += 'For <span class="bold">Curbside Pickup. In Store Pickup</span> is unavailable at this time.';
      fireLinkTagMessage = `In Store:NA-Curbside:${pickupAvailabilityMessage}`;
      break;
    default:
      fireLinkTagMessage = 'In Store:NA-Curbside:NA';
      break;
  }
  productModel.get('viewState').fireLinkTagBossMessage = fireLinkTagMessage;
  return bossMessage;
}
function getEventMessaging(productModel) {
  const availability = productModel.get('viewState').detail.selectedUpcItem.availability ? productModel.get('viewState').detail.selectedUpcItem.availability : { bopsAvailability: false, bossAvailability: false };
  const inStoreCurbsidePickupEnabled = productModel.get('properties') && productModel.get('properties').inStoreCurbsidePickupEnabled;
  const { fireLinkTagBopsMessage } = productModel.get('viewState');
  const { fireLinkTagBossMessage } = productModel.get('viewState');
  let pickupAvailabilityUpper = '';
  let bopsPickupAvailabilityMessage = '';
  let bossPickupAvailabilityMessage = '';
  if (typeof availability.pickupAvailabilityMessage !== 'undefined') {
    pickupAvailabilityUpper = availability.pickupAvailabilityMessage.toUpperCase();
    bopsPickupAvailabilityMessage = pickupAvailabilityUpper === 'TODAY' || pickupAvailabilityUpper === 'TOMORROW' ? pickupAvailabilityUpper : 'OTHER';
    bossPickupAvailabilityMessage = pickupAvailabilityUpper.replace(/-/g, ' TO ');
  }
  const bopsOldMessage = `BOPS:${bopsPickupAvailabilityMessage}`;
  const bossOldMessage = `BOSS:${bossPickupAvailabilityMessage}`;
  const oldUnavailable = 'NA1.0';
  let pickupEligibility = '';
  if (availability.bopsAvailability === true) {
    pickupEligibility = inStoreCurbsidePickupEnabled ? fireLinkTagBopsMessage : bopsOldMessage;
  } else if (availability.bopsAvailability === false && availability.bossAvailability === true) {
    pickupEligibility = inStoreCurbsidePickupEnabled ? fireLinkTagBossMessage : bossOldMessage;
  } else {
    pickupEligibility = inStoreCurbsidePickupEnabled ? 'NA' : oldUnavailable;
  }
  return pickupEligibility;
}

module.exports = {
  inStoreCurbsidePickupMessage,
  checkCutOffTime,
  checkPickupEligibility,
  bossPickupMessagging,
  getEventMessaging,
};



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/helpers/pickupMessaging.js